
<div class="well-info-item">
  <mat-label>Comments</mat-label>
  @if (wellReuqestLog?.comments) {
    <span>{{ wellReuqestLog?.comments }}</span>
  } @else {
    <span>N/A</span>
  }
</div>
